import { ReactElement } from 'react'
import { Button, Heading, SVG } from '../../Atoms'
import Flex from '../Flex'
import { StyledSuccessConfirmationButton } from './styles'
import { SuccessConfirmationBtnProps } from './props'
import { SVGs } from '../..'

const SuccessConfirmationButton = ({
    headerIcon,
    header,
    text,
    continuebtn,
    closebtn,
    onClickCloseBtn,
    onClickContinueBtn,
    showConfirmButton,
}: SuccessConfirmationBtnProps): ReactElement => (
    <StyledSuccessConfirmationButton>
        <Flex
            alignItems={'center'}
            css={{
                mb: '$2',
            }}
        >
            <SVG
                src={headerIcon}
                css={{
                    fontSize: 24,
                    color: '$secondary600',
                }}
            />
            <Heading
                css={{
                    ml: '$2',
                }}
                size={'4'}
                level={4}
                bold
            >
                {header}
            </Heading>
        </Flex>
        {text}
        <Flex
            justifyContent={'flex-end'}
            css={{
                mt: '$3',
            }}
        >
            <Button defaultChecked onClick={onClickCloseBtn}>
                {closebtn}
            </Button>
            {showConfirmButton && (
                <Button
                    css={{
                        display: 'flex',
                        ml: '$3',
                    }}
                    variant={'success'}
                    onClick={onClickContinueBtn}
                >
                    {continuebtn}{' '}
                    <SVG
                        src={SVGs.ChevronRight}
                        css={{
                            fontSize: 14,
                            pl: '$4',
                        }}
                    ></SVG>
                </Button>
            )}
        </Flex>
    </StyledSuccessConfirmationButton>
)

export default SuccessConfirmationButton

export { StyledSuccessConfirmationButton }
